import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gradient-navy section-decorated min-h-[90vh] flex items-center relative" }
const _hoisted_2 = { class: "container mx-auto px-4 py-32 relative z-10" }
const _hoisted_3 = { class: "grid lg:grid-cols-2 gap-12 items-center" }
const _hoisted_4 = { class: "max-w-3xl" }
const _hoisted_5 = { class: "text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6" }
const _hoisted_6 = { class: "text-gradient" }
const _hoisted_7 = { class: "text-lg sm:text-xl text-white/70 leading-relaxed max-w-2xl mb-10" }
const _hoisted_8 = { class: "flex flex-wrap gap-4" }
const _hoisted_9 = { class: "bg-white section-decorated py-12 md:py-16" }
const _hoisted_10 = { class: "container mx-auto px-4" }
const _hoisted_11 = { class: "text-center mb-16" }
const _hoisted_12 = { class: "text-td-blue font-semibold text-sm uppercase tracking-wider mb-3" }
const _hoisted_13 = { class: "text-3xl md:text-4xl font-extrabold text-td-navy mb-4" }
const _hoisted_14 = { class: "grid sm:grid-cols-2 lg:grid-cols-4 gap-6" }
const _hoisted_15 = { class: "w-12 h-12 rounded-xl bg-td-blue/10 flex items-center justify-center mb-5 group-hover:bg-td-blue/20 transition-colors" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "text-lg font-bold text-td-navy mb-2" }
const _hoisted_18 = { class: "text-sm text-td-gray leading-relaxed" }
const _hoisted_19 = { class: "gradient-navy section-decorated py-12" }
const _hoisted_20 = { class: "container mx-auto px-4 relative z-10" }
const _hoisted_21 = { class: "grid sm:grid-cols-2 lg:grid-cols-4 gap-8" }
const _hoisted_22 = { class: "text-4xl md:text-5xl font-extrabold text-white mb-2" }
const _hoisted_23 = { class: "text-td-blue-light text-sm font-semibold uppercase tracking-wider" }
const _hoisted_24 = { class: "bg-td-lighter section-decorated py-12 md:py-16" }
const _hoisted_25 = { class: "container mx-auto px-4" }
const _hoisted_26 = { class: "grid md:grid-cols-2 gap-12 items-center" }
const _hoisted_27 = { class: "text-td-blue font-semibold text-sm uppercase tracking-wider mb-3" }
const _hoisted_28 = { class: "text-3xl md:text-4xl font-extrabold text-td-navy mb-6" }
const _hoisted_29 = { class: "text-td-gray leading-relaxed mb-6" }
const _hoisted_30 = { class: "space-y-4" }
const _hoisted_31 = { class: "font-bold text-td-navy" }
const _hoisted_32 = { class: "text-sm text-td-gray" }
const _hoisted_33 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_34 = { class: "font-bold text-td-navy text-sm" }
const _hoisted_35 = { class: "bg-white section-decorated py-12 md:py-16" }
const _hoisted_36 = { class: "container mx-auto px-4" }
const _hoisted_37 = { class: "gradient-navy rounded-3xl p-10 md:p-16 text-center relative overflow-hidden" }
const _hoisted_38 = { class: "relative z-10" }
const _hoisted_39 = { class: "text-3xl md:text-4xl font-extrabold text-white mb-4" }
const _hoisted_40 = { class: "text-white/60 max-w-xl mx-auto mb-8" }

import { computed } from "vue";
import HeroVisual from "@/components/HeroVisual.vue";
import { useI18n } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t } = useI18n();

const serviceIcons = [
  '<svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" /></svg>',
  '<svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" /></svg>',
  '<svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>',
  '<svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" /></svg>',
];

const services = computed(() =>
  t.value.home.services.items.map((item, i) => ({ ...item, icon: serviceIcons[i] }))
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 grid-bg opacity-50" }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute top-20 right-10 w-72 h-72 rounded-full glow-orb-10 animate-float" }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute bottom-20 left-10 w-96 h-96 rounded-full glow-orb-5 animate-float-delayed" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute top-1/2 left-1/2 w-[500px] h-[500px] rounded-full glow-orb-5 -translate-x-1/2 -translate-y-1/2" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(t).home.hero.titleLine1) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t).home.hero.titlePre), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t).home.hero.titleHighlight), 1),
              _createTextVNode(_toDisplayString(_unref(t).home.hero.titlePost), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t).home.hero.paragraph), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/portfolio",
                class: "btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t).home.hero.viewWork) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M17 8l4 4m0 0l-4 4m4-4H3"
                    })
                  ], -1))
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/contact",
                class: "btn-outline border-white/20 text-white hover:bg-white hover:text-td-navy"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t).home.hero.contactUs), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(HeroVisual, { class: "hidden lg:block" })
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "wave-divider -bottom-px" }, [
        _createElementVNode("svg", {
          viewBox: "0 0 1440 80",
          preserveAspectRatio: "none",
          class: "block w-full h-12 md:h-20 -mb-px"
        }, [
          _createElementVNode("path", {
            d: "M0,40 C360,80 720,0 1080,50 C1260,70 1380,30 1440,40 L1440,80 L0,80 Z",
            fill: "#ffffff"
          })
        ])
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t).home.services.kicker), 1),
          _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(t).home.services.title), 1),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-16 h-1 bg-td-blue rounded-full mx-auto" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
            return (_openBlock(), _createElementBlock("div", {
              key: service.title,
              class: "group p-6 rounded-2xl border border-td-light hover:border-td-blue/20 hover:shadow-xl hover:shadow-td-blue/5 transition-all duration-300 hover:-translate-y-1"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "text-td-blue",
                  innerHTML: service.icon
                }, null, 8, _hoisted_16)
              ]),
              _createElementVNode("h3", _hoisted_17, _toDisplayString(service.title), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(service.description), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 grid-bg opacity-30" }, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute top-0 left-1/4 w-64 h-64 rounded-full glow-orb-10" }, null, -1)),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t).home.stats, (stat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stat.label,
              class: "text-center"
            }, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(stat.value), 1),
              _createElementVNode("p", _hoisted_23, _toDisplayString(stat.label), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t).home.industries.kicker), 1),
            _createElementVNode("h2", _hoisted_28, _toDisplayString(_unref(t).home.industries.title), 1),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t).home.industries.paragraph), 1),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t).home.industries.items, (industry) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: industry.title,
                  class: "flex items-start gap-4"
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-8 h-8 rounded-lg bg-td-blue/10 flex items-center justify-center shrink-0 mt-0.5" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-td-blue",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M5 13l4 4L19 7"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(industry.title), 1),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(industry.description), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t).home.industries.technologies, (tech) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tech,
                class: "card-glass p-5 text-center"
              }, [
                _createElementVNode("p", _hoisted_34, _toDisplayString(tech), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-0 grid-bg opacity-20" }, null, -1)),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute top-0 right-0 w-64 h-64 rounded-full glow-orb-10" }, null, -1)),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute bottom-0 left-0 w-48 h-48 rounded-full glow-orb-10" }, null, -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("h2", _hoisted_39, _toDisplayString(_unref(t).home.cta.title), 1),
            _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(t).home.cta.paragraph), 1),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "btn-primary text-base px-10 py-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t).home.cta.button) + " ", 1),
                _cache[11] || (_cache[11] = _createElementVNode("svg", {
                  class: "w-5 h-5",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M17 8l4 4m0 0l-4 4m4-4H3"
                  })
                ], -1))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})